import api from "./api";
import auth from "./auth";

export default {
	getCustomerDesigns() {
		return new Promise((resolve, reject) => {
			api.post("design-service/customer/list", {}, auth.getHeader())
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(errors);
				});
		});
	},
	getCustomerDesignDetails(uuid) {
		return new Promise((resolve, reject) => {
			api.get("design-service/customer/view/" + uuid, auth.getHeader())
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(errors);
				});
		});
	},
	createCustomerDesign(data) {
		return new Promise((resolve, reject) => {
			api.post("design-service/customer/create", data, auth.getHeader())
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(errors);
				});
		});
	},
	updateCustomerDesign(uuid, data) {
		return new Promise((resolve, reject) => {
			api.post(
				"design-service/customer/update/" + uuid,
				data,
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(errors);
				});
		});
	},
	publishCustomerDesign(data) {
		return new Promise((resolve, reject) => {
			api.post(
				"design-service/customer/publish/" + data.uuid,
				{ published: data.published },
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(errors);
				});
		});
	},
	deleteCustomerDesign(uuid) {
		return new Promise((resolve, reject) => {
			api.delete(
				"design-service/customer/delete/" + uuid,
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(errors);
				});
		});
	},
	getMerchantDesigns() {
		return new Promise((resolve, reject) => {
			api.post("design-service/merchant/list", {}, auth.getHeader())
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(errors);
				});
		});
	},
	getMerchantDesignDetails(uuid) {
		return new Promise((resolve, reject) => {
			api.get("design-service/merchant/view/" + uuid, auth.getHeader())
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(errors);
				});
		});
	},
	createMerchantDesign(data) {
		return new Promise((resolve, reject) => {
			api.post("design-service/merchant/create", data, auth.getHeader())
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(errors);
				});
		});
	},
	updateMerchantDesign(uuid, data) {
		return new Promise((resolve, reject) => {
			api.post(
				"design-service/merchant/update/" + uuid,
				data,
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(errors);
				});
		});
	},
	publishMerchantDesign(data) {
		return new Promise((resolve, reject) => {
			api.post(
				"design-service/merchant/publish/" + data.uuid,
				{ published: data.published },
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(errors);
				});
		});
	},
	deleteMerchantDesign(uuid) {
		return new Promise((resolve, reject) => {
			api.delete(
				"design-service/merchant/delete/" + uuid,
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(errors);
				});
		});
	},
	publishFeatureBanner(param) {
		return new Promise((resolve, reject) => {
			api.post(
				"design-service/feature/banner/create",
				param,
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(status, errors);
				});
		});
	},
	viewFeatureBanner(uuid) {
		return new Promise((resolve, reject) => {
			api.get("design-service/feature/banner/view/" + uuid, auth.getHeader())
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(status, errors);
				});
		});
	},
	updateFeatureBanner(uuid, data) {
		return new Promise((resolve, reject) => {
			api.post(
				"design-service/feature/banner/update/" + uuid,
				data,
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(status, errors);
				});
		});
	},
	deleteFeatureBanner(uuid) {
		return new Promise((resolve, reject) => {
			api.delete(
				"design-service/feature/banner/delete/" + uuid,
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(status, errors);
				});
		});
	},
	getFeaturedBannerList() {
		return new Promise((resolve, reject) => {
			api.get("design-service/feature/banner/list", auth.getHeader())
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(status, errors);
				});
		});
	},
	publishDesign(param) {
		return new Promise((resolve, reject) => {
			api.post("design-service/feature/banner/publish/" + param.uuid, param, auth.getHeader())
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(status, errors);
				});
		});
	},
	createWebDesign({ payload, trackOnboarding }) {
		return new Promise((resolve, reject) => {
			api.post(
				trackOnboarding ? "design-service/v2/api/web/create" : "design-service/web/create",
				payload,
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(status, errors);
				});
		});
	},
	getWebDesigns() {
		return new Promise((resolve, reject) => {
			api.get("design-service/web/list", auth.getHeader())
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(status, errors);
				});
		});
	},
	deleteWebDesign(uuid) {
		return new Promise((resolve, reject) => {
			api.delete(
				"design-service/web/delete/" + uuid,
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(status, errors);
				});
		});
	},
	viewWebDesign(uuid) {
		return new Promise((resolve, reject) => {
			api.get("design-service/web/view/" + uuid, auth.getHeader())
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(status, errors);
				});
		});
	},
	updateWebDesign(uuid, data) {
		return new Promise((resolve, reject) => {
			api.post(
				"design-service/web/update/" + uuid,
				data,
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(status, errors);
				});
		});
	},
	publishWebDesign(param) {
		return new Promise((resolve, reject) => {
			api.post("design-service/web/publish/" + param.uuid,
				param,
				auth.getHeader())
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(status, errors);
				});
		});
	},
	// News & Pop Up
	getNewsPopUp(param) {
		return new Promise((resolve, reject) => {
			api.get(
				`design-service/news-pop-up/list/${param}`,
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(status, errors);
				});
		});
	},
	getGeneralSettings() {
		return new Promise((resolve, reject) => {
			api.get(
				'design-service/news/settings',
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(status, errors);
				});
		});
	},
	saveGeneralSettings(param) {
		return new Promise((resolve, reject) => {
			api.post(
				'design-service/news/settings',
				param,
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, error) => {
					reject(status, error);
				});
		});
	},
	getAdvancedSettingsOurBrands() {
		return new Promise((resolve, reject) => {
			api.get(
				'design-service/v2/api/cms/web-store/our-brands',
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, error) => {
					reject(status, error);
				});
		});
	},
	getAboutUs() {
		return new Promise((resolve, reject) => {
			api.get(
				'design-service/v2/api/cms/web-store/about-us',
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, error) => {
					reject(status, error);
				});
		});
	},
	saveAdvancedSettingsOurBrands(payload) {
		return new Promise((resolve, reject) => {
			api.post(
				'design-service/v2/api/cms/web-store/our-brands/create',
				payload,
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, error) => {
					reject(status, error);
				});
		})
	},
	saveAboutUs(payload) {
		return new Promise((resolve, reject) => {
			api.post(
				'design-service/v2/api/cms/web-store/about-us/create',
				payload,
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, error) => {
					reject(status, error);
				});
		})
	},
	getAdvancedSettingsCategories() {
		return new Promise((resolve, reject) => {
			api.get(
				'design-service/v2/api/cms/web-store/categories',
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, error) => {
					reject(status, error);
				});
		});
	},
	saveAdvancedSettingsCategories(payload) {
		return new Promise((resolve, reject) => {
			api.post(
				'design-service/v2/api/cms/web-store/categories/create',
				payload,
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, error) => {
					reject(status, error);
				});
		});
	},
	saveIconsAndLogos(payload) {
		return new Promise((resolve, reject) => {
			api.post(
				'design-service/v2/api/cms/web-store/icons/create',
				payload,
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, error) => {
					reject(status, error);
				});
		});
	},
	getIconsAndLogos() {
		return new Promise((resolve, reject) => {
			api.get(
				'design-service/v2/api/cms/web-store/icons',
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, error) => {
					reject(status, error);
				});
		});
	},
	getSnippetDetails() {
		return new Promise((resolve, reject) => {
			api.get(
				'design-service/v2/api/cms/web-store/snippet-details',
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, error) => {
					reject(status, error);
				});
		});
	},
	getAdvancedSettingsWebSequence() {
		return new Promise((resolve, reject) => {
			api.get(
				'design-service/v2/api/cms/web-store/section-order',
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, error) => {
					reject(status, error);
				});
		});
	},
	saveAdvancedSettingsWebSequence(payload) {
		return new Promise((resolve, reject) => {
			api.post(
				'design-service/v2/api/cms/web-store/section-order/create',
				payload,
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, error) => {
					reject(status, error);
				});
		});
	},
	saveSnippetDetails(payload) {
		return new Promise((resolve, reject) => {
			api.post(
				'design-service/v2/api/cms/web-store/snippet-details/create',
				payload,
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, error) => {
					reject(status, error);
				});
		});
	},
	saveOrderStatusSettings(payload) {
		return new Promise((resolve, reject) => {
			api.post(
				'design-service/v2/api/cms/order-status-design/create',
				payload,
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, error) => {
					reject(status, error);
				});
		});
	},
	getOrderStatusSettings() {
		return new Promise((resolve, reject) => {
			api.get(
				'design-service/v2/api/cms/order-status-design/all',
				auth.getHeader()
			)
				.then(response => {
					return resolve(response);
				})
				.catch((status, error) => {
					reject(status, error);
				});
		});
	},
	getGLifeDesignList() {
		return new Promise((resolve, reject) => {
			api.get(
				'design-service/customer/glife/design/list',
				auth.getHeader()
			)
				.then(response => resolve(response))
				.catch(e => reject(e.errors));
		});
	},
	createGLifeDesign(payload) {
    return new Promise((resolve, reject) => {
			api.post(
				'design-service/customer/glife/design/create',
				payload,
				auth.getHeader()
			)
				.then(response => resolve(response))
				.catch(e => reject(e.errors));
		});
	},
	updateGLifeDesign(payload) {
		return new Promise((resolve, reject) => {
			api.post(
				'design-service/customer/glife/design/update',
				payload,
				auth.getHeader()
			)
				.then(response => resolve(response))
				.catch(e => reject(e.errors));
		});
	},
	publishGLifeDesign(payload) {
		return new Promise((resolve, reject) => {
			api.post(
				'design-service/customer/glife/design/publish',
				payload,
				auth.getHeader()
			)
				.then(response => resolve(response))
				.catch(e => reject(e.errors));
		});
	},
	getGLifeDesignDetails(uuid) {
		return new Promise((resolve, reject) => {
			api.get(
				`design-service/customer/glife/design/view/${uuid}`,
				auth.getHeader()
			)
				.then(response => resolve(response))
				.catch(e => reject(e.errors));
		});
	},
  deleteGLifeDesign(uuid) {
		return new Promise((resolve, reject) => {
			api.delete(
				`design-service/customer/glife/design/delete/${uuid}`,
				auth.getHeader()
			)
				.then(response => resolve(response))
				.catch(e => reject(e.errors));
		});
	},
};
